// AVISO DIÁRIO DE ATUALIZAÇÃO DO ESTÁDIO
//
// Regra: o popup de novidades aparece no MÁXIMO uma vez por dia civil, e o dia é
// contado pelo RELÓGIO LOCAL do telemóvel — nunca por UTC. Se usássemos
// toISOString(), o "dia" virava à meia-noite de Londres, por isso um craque em
// Lisboa no horário de verão (UTC+1) veria o aviso outra vez às 23h, e um no
// Brasil (UTC-3) só o veria depois das 21h. Com a hora local, vira à meia-noite
// de quem está a jogar.
//
// Tudo o que toca no localStorage está protegido: em navegação privada, com
// cookies bloqueados, ou dentro de um iframe sandboxed, o próprio ACESSO à
// propriedade atira uma exceção — não basta verificar se o valor existe.

const CHAVE_ARMAZENAMENTO = 'gamefut:atualizacaoEstadioVistaEm';
const FORMATO_AAAA_MM_DD = /^\d{4}-\d{2}-\d{2}$/;

// Converte uma data para AAAA-MM-DD na hora local. Uma data inválida cai para agora.
export function dataLocalAAAAMMDD(quando = new Date()) {
  const data = (quando instanceof Date && !Number.isNaN(quando.getTime())) ? quando : new Date();
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const dia = String(data.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}

// Lê o registo guardado. Devolve null se não existir, se o localStorage não
// estiver disponível, ou se o valor estiver corrompido (lixo, null, "undefined",
// um formato antigo...). Null significa sempre "trata como se nunca tivesse visto".
function lerRegisto() {
  try {
    const bruto = window.localStorage.getItem(CHAVE_ARMAZENAMENTO);
    return FORMATO_AAAA_MM_DD.test(bruto || '') ? bruto : null;
  } catch {
    return null;
  }
}

// Deve o aviso aparecer agora? Só lê — não escreve nada.
// Um registo com data futura (relógio do telemóvel trocado) também é diferente de
// hoje, por isso mostra: mais vale mostrar duas vezes do que ficar preso para sempre.
export function shouldShowStadiumUpdate(quando = new Date()) {
  return lerRegisto() !== dataLocalAAAAMMDD(quando);
}

// Marca o aviso como visto hoje. Chamar SÓ depois de decidir mostrar o popup.
// Devolve false se não conseguiu gravar (modo privado) — nesse caso o aviso volta
// a aparecer na próxima sessão, que é o comportamento menos mau dos dois.
export function markStadiumUpdateShown(quando = new Date()) {
  try {
    window.localStorage.setItem(CHAVE_ARMAZENAMENTO, dataLocalAAAAMMDD(quando));
    return true;
  } catch {
    return false;
  }
}

// Apaga o registo para o aviso voltar a aparecer. Usado nos testes de verificação.
export function resetStadiumUpdate() {
  try {
    window.localStorage.removeItem(CHAVE_ARMAZENAMENTO);
    return true;
  } catch {
    return false;
  }
}
